import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import { ConditionType } from "../return-flow/condition";
import { RuleTypeDetailsProps } from "./multiple-actions";

export type TopicState = string[];

export const TOPIC = (
  Details: React.ComponentType<RuleTypeDetailsProps<TopicState>>,
): ConditionType<TopicState, ModelCondition.Topic> => ({
  name: CONDITION_NAMES[ModelCondition.TOPIC],
  description() {
    return t("What is the topic of the customer message");
  },
  Details(props: RuleTypeDetailsProps<TopicState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.topics;
  },
  toModel(state) {
    return { type: ModelCondition.TOPIC, topics: state };
  },
  valid() {
    return true;
  },
});
